import React, { useState } from 'react';
import './settings.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { getSettingsData } from '../reducer';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import DropdownList from '../../../components/base/Dropdown/DropdownList';
import { EXPORT_TYPE_ENUM } from '../../../configs';
import ExportFTPForm from './ExportFTPForm';
import ExportDuploForm from './ExportDuploForm';
import { statusClassName } from '../../../utils/formatters';
import { showGlobalConfirm } from '../../System/actions';
import { deleteExport, saveExport, updateExport } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';

export default function ViolationExportColumn(props) {
  const { loadData = () => {} } = props;
  const [isEdit, setIsEdit] = useState(false);
  const [type, setType] = useState(null);
  const [editItem, setEditItem] = useState({});
  const {
    exportList,
    violationList,
  } = useSelector(getSettingsData);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const list = exportList ? exportList.filter(f => f.violation_types && f.violation_types.length) : [];
  const handleCreate = type => () => {
    setIsEdit(true);
    setType(type);
  };
  const editExport = item => () => {
    setIsEdit(true);
    setType(item.uploader_type);
    setEditItem(item);
  };
  const handleDeleteExport = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'app.delete.message' }, { name: `${item.uploader_name || ''} (${formatMessage({ id: `export.type.${item.uploader_type}` })})` }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteExport(item.id)).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'export.delete.title' }), formatMessage({ id: 'export.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'export.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const save = data => {
    const action = !editItem || !editItem.id
      ? saveExport({
        uploader_url: '', uploader_username: '', uploader_password: '', ...data, uploader_type: type,
      })
      : updateExport({
        id: editItem.id,
        pool: {
          uploader_url: '', uploader_username: '', uploader_password: '', ...data, uploader_type: type,
        },
      });
    dispatch(action).then(() => {
      loadData();
      setIsEdit(false);
      setType(null);
      setEditItem(null);
      successNotification(formatMessage({ id: 'export.save' }), formatMessage({ id: 'export.save.success' }));
    }).catch(response => {
      errorNotification(formatMessage({ id: 'export.save' }), getResponseError(response));
    });
  };

  const cancel = () => {
    setIsEdit(false);
    setType(null);
    setEditItem({});
  };

  const renderListItem = (item, key) => {
    const vc = item.violation_types ? item.violation_types : [];
    return (
      <div className="export-list-item" key={key}>
        <div className="f3 mb-3 export-item-name">
          ({formatMessage({ id: `export.type.${item.uploader_type}` })})
          <div className="edit-and-delete-buttons">
            <div className="menu-item-button" onClick={editExport(item)}><Icons
              customIcon
              icon="pencil"
              width={16}
              height={16}
            />
            </div>
            <div className="menu-item-button" onClick={handleDeleteExport(item)}><Icons
              customIcon
              icon="trash"
              width={16}
              height={16}
            />
            </div>
          </div>
        </div>
        <div className="settings-view-row">
          <div className="settings-view-label">{formatMessage({ id: 'export.data.url' })}:</div>
          <div className="settings-view-value">
            <div className="status-wrapper">
              {item?.uploader_url || ''}
            </div>
          </div>
        </div>
        <div className="settings-view-row">
          <div className="settings-view-label">{formatMessage({ id: 'export.status' })}:</div>
          <div className="settings-view-value">
            <div className="status-wrapper">
              <div className={classNames('export-block-indicator indicator indicator-1', statusClassName(Number(item.status)))} />
              {formatMessage({ id: `local.folder.status.${item.status}` }) || ''}
            </div>
          </div>
        </div>
        <div className="settings-view-row">
          <div className="settings-view-label">{formatMessage({ id: 'queue.length' })}:</div>
          <div className="settings-view-value">
            <div className="status-wrapper">
              <div className={classNames('export-block-indicator indicator indicator-1', statusClassName(Number(item.queue > 20 ? 2 : item.queue >= 10 ? 1 : 0)))} />
              {item.queue}
            </div>
          </div>
        </div>
        <div className="settings-view-row">
          <div className="settings-view-label">{formatMessage({ id: 'export.data.violation_types' })}:</div>
          <div className="settings-view-value">{vc.map(value => {
            const f = violationList.find(i => i.id === value);
            return f?.code_description || `Неизвестное основание ${value}`;
          })}
          </div>
        </div>
      </div>
    );
  };

  const renderAddButton = () => (
    <DropdownList menuClassName="export-option-wrapper" buttonClassName="add-export-btn" variant="secondary" label={<><Icons customIcon icon="plus" /> {formatMessage({ id: 'app.create' })}</>}>
      <div className="export-option-list">
        <div className="export-option" onClick={handleCreate(EXPORT_TYPE_ENUM.FTP)}>{formatMessage({ id: `export.type.${EXPORT_TYPE_ENUM.FTP}` })}</div>
        <div className="export-option" onClick={handleCreate(EXPORT_TYPE_ENUM.DUPLO)}>{formatMessage({ id: `export.type.${EXPORT_TYPE_ENUM.DUPLO}` })}</div>
      </div>
    </DropdownList>
  );

  return (
    <div className="settings-options frame export-data-column">
      <div className="settings-edit">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'column.checkbox' })}</div>
        </div>
        {!list.length && !isEdit ? (
          <div className="settings-form export-form">
            <div className="empty-list">
              <div className="empty-list-text">
                {formatMessage({ id: 'export.settings.not.found' })}
                <div className="empty-list-buttons">{renderAddButton()}</div>
              </div>
            </div>
          </div>
        ) : null}

        {list.length && !isEdit ? (
          <div className="settings-form">
            <div className="settings-view-form">
              {list.map(renderListItem)}
              <div className="mt-3">
                {renderAddButton()}
              </div>
            </div>
          </div>
        ) : null}
        {isEdit && type === EXPORT_TYPE_ENUM.FTP ? <ExportFTPForm data={editItem} save={save} cancel={cancel} /> : null}
        {isEdit && type === EXPORT_TYPE_ENUM.DUPLO ? <ExportDuploForm data={editItem} save={save} cancel={cancel} /> : null}
      </div>
    </div>
  );
}
